var _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesigncenter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 279,
    height: 193,
    viewBox: "0 0 279 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    width: 66.6572,
    height: 65.2686,
    transform: "matrix(0.707941 0.706272 0.706272 -0.707941 98.751 95.7891)",
    fill: "#00AEEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 136.092,
    height: 134.703,
    transform: "matrix(0.707941 0.706272 0.706272 -0.707941 0.555664 95.9062)",
    fill: "#00AEEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 126.371,
    height: 127.76,
    transform: "matrix(0.707941 0.706272 0.706272 -0.707941 98.751 95.7891)",
    fill: "#00AEEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesigncenter);
export default __webpack_public_path__ + "static/media/Design center.bb1d847095098237a1cc041d02a7a090.svg";
export { ForwardRef as ReactComponent };